import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { customerOperations } from '../stores/customer-store'
import { WritersService } from '../services/writers-service'
import { errorToast } from '../toaster'
import { donePromise } from '../utils'


@Injectable({providedIn: 'root'})
export class WriterActions {
  writersService: WritersService = new WritersService();
  fetchWriterError: string = 'An error occurred while loading writer information, please reload this page';

  loadWriterBySlug(writerSlug: string, options: Object = {}): Promise<any> {
    const p = this.writersService.getWriterBySlug(writerSlug, options).then((writer) => {
      reactor.dispatch(customerOperations.setWriter, writer)
    })
    .catch(() => {
      errorToast(this.fetchWriterError)
    })
    return donePromise(p)
  }
}
